import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { clearReportStatus, reportStatus, subscribeReportStatus } from "../lib/reportCache";
import { invalidateOverviewCache } from "../lib/overviewCache";

export default function ReportFreshness({ onRefresh, contextKey }) {
  const location = useLocation();
  const page = location.pathname + location.search + "|" + contextKey;
  const [, update] = useState(0);
  useEffect(() => subscribeReportStatus(() => update((value) => value + 1)), []);
  const status = reportStatus(page);
  if (status === "idle") return null;
  const refresh = () => {
    if (status === "error") invalidateOverviewCache();
    clearReportStatus(page);
    onRefresh();
  };
  return <div role="status" data-testid="report-freshness" style={{ padding: "10px 24px", background: "#fff6df", color: "#614b19" }}>
    {status === "refreshing" ? "Son görüntülenen sonuçlar gösteriliyor. Güncelliği kontrol ediliyor…" :
      status === "error" ? "Son görüntülenen sonuçlar gösteriliyor. Güncel veriler kontrol edilemedi. " :
      "Güncel sonuçlar hazır. "}
    {status !== "refreshing" && <button className="outline-button" onClick={refresh}>
      {status === "error" ? "Tekrar dene" : "Güncel sonuçları göster"}
    </button>}
  </div>;
}
